import { createContext, useEffect, useState } from 'react';
import { COLLABORATION_CHANGED, loadCollaboration } from '../services/collaborationService';

export const collaborationEnabled = process.env.REACT_APP_COLLABORATION_ENABLED === 'true';
export const CollaborationAccessContext = createContext({ sharedModules: [] });
export function useCollaborationAccess(userId) {
  const [sharedModules, setSharedModules] = useState([]);
  useEffect(() => {
    let active = true;
    let request = 0;
    setSharedModules([]);
    const update = async () => {
      if (!collaborationEnabled || !userId) return;
      const currentRequest = ++request;
      try {
        const result = await loadCollaboration();
        const modules = [...new Set(result.shared_modules || [])].sort();
        if (active && request === currentRequest) setSharedModules(current => JSON.stringify(current) === JSON.stringify(modules) ? current : modules);
      } catch { if (active && request === currentRequest) setSharedModules([]); }
    };
    update();
    window.addEventListener(COLLABORATION_CHANGED, update);
    const timer = collaborationEnabled ? window.setInterval(update, 30000) : null;
    return () => { active = false; window.removeEventListener(COLLABORATION_CHANGED, update); if (timer) window.clearInterval(timer); };
  }, [userId]);
  return { sharedModules };
}
